import { AxiosError } from 'axios';

import { getLogger } from '@/logging';

const REDACTED_HEADERS = new Set([
  'x-auth-access-token',
  'x-auth-id-token',
  'x-api-key',
  'authorization',
]);

export function redactHeaders(
  headers: Record<string, unknown> | undefined
): Record<string, unknown> | undefined {
  if (!headers) return undefined;

  return Object.fromEntries(
    Object.entries(headers).map(([key, value]) => [
      key,
      REDACTED_HEADERS.has(key.toLowerCase()) ? '[REDACTED]' : value,
    ])
  );
}

export function buildSafeAxiosErrorLogEntry(error: AxiosError) {
  return {
    url: error.config?.url,
    method: error.config?.method,
    requestHeaders: redactHeaders(
      error.config?.headers as Record<string, unknown>
    ),
    requestBody: error.config?.data,
    status: error.response?.status,
    statusText: error.response?.statusText,
    responseData: error.response?.data,
    responseHeaders: error.response?.headers,
    code: error.code,
    errorMessage: error.message,
  };
}

export function logAxiosError(error: AxiosError) {
  getLogger().debug({
    message: 'axios error received',
    ...buildSafeAxiosErrorLogEntry(error),
  });
}
